export const SEARCH_ROUTE = '/Hotel/Search'
export const PROVIDER_REDIRECT_ROUTE = '/ProviderRedirect'
export const ALERTS_ROUTE = '/user/alerts'
export const ACCOUNT_ROUTE = '/user/account'
export const REFERRAL_ROUTE = '/user/membership/referral'
export const EMAIL_PREFERENCES_ROUTE = '/user/notification-preferences'

// Added as a part of c747927f-deal-freeze-srp.
export const DF_TOAST_PARAM = 'dfToast'

// Set when the user clicks "More deals" on the SRP so the AP opens the all-offers overlay on load.
export const SHOW_ALL_OFFERS_PARAM = 'showAllOffers'
